import React from 'react';
import './VideoDescription.css';

const VideoDescription = () => {
  return (
    <section className="video-description text-center text-white">
      <h2 className="video-title mb-3">I Am Cat Singleplayer</h2>
      <div className="container" style={{maxWidth: '400px;'}}>
        <div className="ratio ratio-16x9">
        <iframe 
          src="https://www.youtube.com/embed/WUnEWydv5jE" 
          allowFullScreen 
          title="YouTube Video"
        ></iframe>
      </div>
      </div>

      <p className="video-text mt-4">
        <span className="bold-text">I Am Cat</span> – a unique virtual reality game like no other! 
        It’s a sandbox adventure centered around a cat protagonist. 
        Immerse yourself in a diverse and exciting world, ready for you to explore.
      </p>
    </section>
  );
};

export default VideoDescription;
